<div class="time-of-the-day">
  <form [formGroup]="timeOfTheDayForm">
    @if (callpage != 'managePrivateRoom') {
    <div class="form-inline">
      <label class="label mt-3">Game Play Day <span class="required me-3">*</span></label>
      <div class="input-group date-input mt-2" style="width: auto;">
        <input class="form-control" id="gamePlayDay" name="gamePlayDay" formControlName="gamePlayDay"
          (dateSelect)="gamePlayDay($event, 'startDate')" ngbDatepicker #startDate="ngbDatepicker" readonly required
          [minDate]="minStartDate">
        <button class="btn btn-outline-secondary calendar" (click)="startDate.toggle()" type="button">
        </button>
      </div>
    </div>
    }
    @if (additionalInfo?.feature_play_avail_time) {
    <div class="text-danger mt-2 ms-1">
      <b>Note: </b><span>Promo time should be greater than Feature Play Availability Time.
      </span><br>
      <span class="mt-1">Current Feature Play Availability Time is
        <b>{{additionalInfo.feature_play_avail_time}}</b>
        (secs) / <b>{{((additionalInfo.feature_play_avail_time)/60).toFixed(2)}}</b> (mins).</span>
    </div>
    }
    <div>
      @if (callpage != 'managePrivateRoom') {
      <label class="label mt-2">Game Play Time <span class="required me-3">*</span></label>
      }
      <div class="mt-2">
        <span class="label ms-2">Time Stamp</span>
      </div>
      <div class="form-inline row mt-3 ms-3">
        <div>
          <label class="label">From</label>
          <div class="input-group date-input date-time form-inline mt-2">
            <input value="{{timeVar.timeStmpFrmhh}}" min="0" max="23" class="hh" type="number" placeholder="HH"
              id="timeStmpFrmhh" [(ngModel)]="timeVar.timeStmpFrmhh" [ngModelOptions]="{standalone: true}"
              (focusout)="hh($event)" (input)="checkDigits($event)">
            &nbsp;:&nbsp;
            <input min="0" max="59" value="{{timeVar.timeStmpFrmmm}}" class="mm" type="number" placeholder="MM"
              id="timeStmpFrmmm" [(ngModel)]="timeVar.timeStmpFrmmm" [ngModelOptions]="{standalone: true}"
              (focusout)="mm($event)" (input)="checkDigits($event)">
            &nbsp;:&nbsp;
            <input min="00" max="59" value="{{timeVar.timeStmpFrmss}}" class="ss" type="number" placeholder="SS"
              id="timeStmpFrmss" [(ngModel)]="timeVar.timeStmpFrmss" [ngModelOptions]="{standalone: true}"
              (focusout)="ss($event)" (input)="checkDigits($event)">
          </div>
        </div>
        <div class="ms-5">
          <label class="label">To</label>
          <div class="input-group date-input date-time form-inline mt-2 ">
            <input value="{{timeVar.timeStmpTohh}}" min="0" max="23" class="hh" type="number" placeholder="HH"
              id="timeStmpTohh" [(ngModel)]="timeVar.timeStmpTohh" [ngModelOptions]="{standalone: true}"
              (focusout)="hh($event)" (input)="checkDigits($event)">
            &nbsp;:&nbsp;
            <input min="0" max="59" value="{{timeVar.timeStmpTomm}}" class="mm" type="number" placeholder="MM"
              id="timeStmpTomm" [(ngModel)]="timeVar.timeStmpTomm" [ngModelOptions]="{standalone: true}"
              (focusout)="mm($event)" (input)="checkDigits($event)">
            &nbsp;:&nbsp;
            <input min="00" max="59" value="{{timeVar.timeStmpToss}}" class="ss" type="number" placeholder="SS"
              id="timeStmpToss" [(ngModel)]="timeVar.timeStmpToss" [ngModelOptions]="{standalone: true}"
              (focusout)="ss($event)" (input)="checkDigits($event)">
          </div>
        </div>
        <div>
          <button type="button" class="gms-btn primary mt-4 pt-2 ms-3" (click)="addTime()">ADD</button>
        </div>
      </div>
      @if (onSave && timeStamps.length==0) {
      <div class="invalid ms-3">
        Please give atleast one Time Stamp
      </div>
      }
      @if (duplicateTime) {
      <div class="invalid ms-3">
        Duplicate Time Stamp
      </div>
      }
      @if (timeRangeError) {
      <div class="invalid ms-3">
        Time Stamp range already exists
      </div>
      }
      @if (incorrectTimeStmp) {
      <div class="invalid ms-3">
        'From' time should be less than 'To' time
      </div>
      }
      @if (timeStamps.length>0) {
      <div class="ms-2 mt-2 time-stamps">
        @for (each of timeStamps; track each; let i = $index) {
        <div class="mb-1">
          {{each.from}} To
          {{each.to}}<span class="ms-3"><text class="remove-txt" (click)="removeTimeStmp(i)">Remove</text></span>
        </div>
        }
      </div>
      }
    </div>
    <label class="label mt-4 ms-1">Days of the week</label>
    @if (callpage != 'managePrivateRoom') {
    <div class="text-danger mt-2 ms-1">
      <b>Note:</b> If Days of the week is not selected, End Date will be same as Game Play Day
    </div>
    }
    <div class="row mt-4 ms-1">
      <select class="form-control ms-2" formControlName="daysOfWeekOp" name="daysOfWeekOp"
        (change)="onChangeDaysofWeek($event)">
        <option value="">--Select--</option>
        <option value="weekly">Weekly</option>
        <option value="monthly">Monthly</option>
      </select>
    </div>
    <div class="row mt-5 ms-1">
      @if (timeOfTheDayForm.controls.daysOfWeekOp.value == 'weekly') {
      <div style="min-height:220px">
        <div class="col-6">
          <div id="weekly">
            <div class="center mt-3">
              <div class="form-inline">
                <div class="input-group date-input date-time">
                  <h5><strong>Repeat Every</strong></h5>
                  <input value="repEvrWeek" min="1" max="53" class="ms-2 hh repeatDay" type="number" id="repEvrWeek"
                    formControlName="repEvrWeek" oninput="validity.valid||(value='');"
                    [ngClass]="{'is-error' : onSave && timeOfTheDayForm.controls.repEvrWeek.invalid}">
                </div>
              </div>
              <div class="form-inline form-control week-days d-flex flex-row flex-wrap gap-1"
                [ngClass]="{'is-error': onSave && selectedDays.length==0}">
                @for (item of onDay; track item) {
                <div class="">
                  <input type="checkbox" [(ngModel)]="item.isSelected" [ngModelOptions]="{standalone: true}"
                    id="{{item.value}}" [value]="item.value"><label for="{{item.value}}"
                    class="button btn-scale-0">{{item.name}}</label>
                </div>
                }
              </div>
              @if (callpage != 'managePrivateRoom') {
              <div class="form-inline mt-3">
                <label class="col-form-label me-2"><strong>End Date</strong></label>
                <div class="input-group date-input" style="width: auto;">
                  <!-- [ngClass]="{'is-error' : onSave
                                    && timeOfTheDayForm.controls.endDate.invalid && !timeOfTheDayForm.controls.daysOfWeekOp.invalid}" -->
                  <input class="form-control" style="width: 170px" name="endDate" readonly [(minDate)]="minEndDate"
                    formControlName="endDate" (dateSelect)="gamePlayDay($event,'endDate')" ngbDatepicker
                    #endDate="ngbDatepicker" required>
                  <button class="btn btn-outline-secondary calendar" (click)="endDate.toggle()"
                    type="button">
                  </button>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
      }
      @if (timeOfTheDayForm.controls.daysOfWeekOp.value == 'monthly') {
      <div style="min-height:220px">
        <div class="col-6">
          <div id="monthly">
            <div class="center mt-3">
              <div class="form-inline">
                <div class="input-group date-input date-time">
                  <h5><strong>Repeat Every</strong></h5>
                  <input min="1" max="12" class="ms-2 hh repeatDay" type="number" formControlName="repEvrMonth"
                    name="repEvrMonth" id="repEvrMonth" [ngClass]="{'is-error' : onSave
                                                        && timeOfTheDayForm.controls.repEvrMonth.invalid}"
                    oninput="validity.valid||(value='');">
                </div>
              </div>
              <div class="form-inline">
                <div class="input-group">
                  <input class="radio-options" type="radio" value="onDay"
                    formControlName="onDayOp" name="onDayOp" (click)="setRadio($event)">
                  <label class="ms-2 form-check-label radio-label">On
                    Day</label>
                  <input min="0" max="31" class="ms-2 hh" type="number" formControlName="onDay"
                    [ngClass]="{'is-error' : onSave
                                                        && timeOfTheDayForm.controls.onDay.invalid && timeOfTheDayForm.controls.onDayOp.value=='onDay'}" [readonly]="!mnthlyDaySelect">
                </div>
              </div>
              <div class="form-inline">
                <input class="radio-options" type="radio" value="onWeek" formControlName="onDayOp" name="onDayOp"
                  (click)="setRadio($event)">
                <label class="ms-2 form-check-label radio-label ">On
                  The</label>
                <span style="display:inline-block">
                  <select class="form-control text-fontsize ms-1 mt-1" formControlName="onTheWeek" id="onTheWeek"
                    [ngClass]="{'is-error' : onSave
                                                        && timeOfTheDayForm.controls.onTheWeek.invalid && timeOfTheDayForm.controls.onDayOp.value=='onWeek'}"
                    (change)="onMonthlyWeek($event)">
                    <option value="">--Select week--</option>
                    @for (item of onTheWeek; track item) {
                    <option [value]="item.value">
                      {{ item.name }}
                    </option>
                    }
                  </select>
                </span>
                <span style="display:inline-block">
                  <select class="form-control text-fontsize ms-1 mt-1" name="onWeekDay" formControlName="onWeekDay"
                    [ngClass]="{'is-error' : onSave
                                                        && timeOfTheDayForm.controls.onWeekDay.invalid && timeOfTheDayForm.controls.onDayOp.value=='onWeek'}"
                    (change)="onMonthlyWeek($event)">
                    <option value="">--Select day--</option>
                    @for (item of onWeekDay; track item) {
                    <option [value]="item.value">
                      {{ item.name }}
                    </option>
                    }
                  </select>
                </span>
              </div>
              @if (callpage != 'managePrivateRoom') {
              <div class="form-inline mt-3">
                <label class="col-form-label me-2"><strong>End Date</strong></label>
                <div class="input-group date-input" style="width: auto;">
                  <input class="form-control" style="width: 170px" name="endDate" [(minDate)]="minEndDate"
                    formControlName="endDate" (dateSelect)="gamePlayDay($event,'endDate')" ngbDatepicker
                    #endDate="ngbDatepicker" required readonly>
                  <!-- [ngClass]="{'is-error' : onSave && timeOfTheDayForm.controls.endDate.invalid &&
                                        !timeOfTheDayForm.controls.daysOfWeekOp.invalid}" -->
                  <button class="btn btn-outline-secondary calendar" (click)="endDate.toggle()"
                    type="button"></button>
                </div>
              </div>
              }
              @if (timeOfTheDayForm.controls.onDayOp.value=='onWeek') {
              <div class="form-inline mt-2">
                Occurs every {{monthlyWeek}} {{monthlyWeekDay}}
              </div>
              }
            </div>
          </div>
        </div>
      </div>
      }
    </div>

    <div class="modal-footer mt-2 pt-1">
      @if (isModalPopup) {
      <button type="button" class="gms-btn secondary" (click)="closeModal()">Close</button>
      }
      <button type="button" class="gms-btn primary ms-2"
        [disabled]="(callpage == 'managePrivateRoom') && (mode == 'view')" (click)="saveConfig()">Save </button>
    </div>
  </form>
</div>